import Gallery from "@/components/editor/shared/sections/gallery/gallery-component";

export default Gallery;
